'use client';

import { useTranslations } from 'next-intl';
import { BodyDefault } from '../../../components/typography';

export function TurnStoppedNotice() {
  const t = useTranslations('designSystem.chat.turnStoppedNotice');

  return <BodyDefault color="fg.muted">{t('description')}</BodyDefault>;
}
